document.addEventListener("DOMContentLoaded", function() {

    const isInViewport = (el) => {
        let bounding = el.getBoundingClientRect();
        return (
            bounding.top >= 0 &&
            bounding.left >= 0 &&
            bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    };

    // vizualni pricitani cisel
    //=========================
    const incrementNumbers = () => {
        let numbers = document.querySelectorAll('.JS-number');
        if (numbers.length === 0)
            return;

        numbers.forEach((el) => {
            if(!isInViewport(el) || el.classList.contains('JS-numberIncremented'))
                return;

            el.classList.add('JS-numberIncremented');
            animJs.number(el, 4000);
        });
    };

    incrementNumbers();

    window.addEventListener('scroll', incrementNumbers);
    window.addEventListener('resize', incrementNumbers);
    window.addEventListener('orientationchange', incrementNumbers);
});